import React from 'react';

// AUTODEX 아이콘 (AX mark in navy square)
function LogoIcon(props) {
  var s = props.size || 40;
  return (
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width={s} height={s}>
      <rect width="48" height="48" rx="10" fill="#1B3A5C"/>
      <path d="M14 32 L18 18 L22 32 M15.5 27 H20.5" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M27 18 L35 32 M35 18 L27 32" stroke="#3B82F6" strokeWidth="3" strokeLinecap="round"/>
    </svg>
  );
}

// AUTODEX 풀 로고 (아이콘 + 텍스트)
function LogoFull(props) {
  var iconSize = props.iconSize || 36;
  var fontSize = props.fontSize || 24;
  var color = props.color || '#1B3A5C';
  var gap = props.gap || 10;
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: gap }}>
      <LogoIcon size={iconSize} />
      <span style={{ fontWeight: 800, fontSize: fontSize, letterSpacing: '-0.02em', color: color }}>{props.text || 'AUTODEX'}</span>
    </div>
  );
}

// 사이드바용 (밝은 텍스트)
function LogoSidebar() {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" width={28} height={28}>
        <rect width="48" height="48" rx="10" fill="#1e3a5f"/>
        <path d="M14 32 L18 18 L22 32 M15.5 27 H20.5" stroke="#60a5fa" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M27 18 L35 32 M35 18 L27 32" stroke="#60a5fa" strokeWidth="3" strokeLinecap="round"/>
      </svg>
      <span style={{ fontWeight: 800, fontSize: 18, letterSpacing: '1px', background: 'linear-gradient(135deg, #22d3ee, #60a5fa)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>AUTODEX</span>
    </div>
  );
}

export { LogoIcon, LogoFull, LogoSidebar };
